import React from "react";
import {
  ListItem,
  ListItemText,
  Button,
  Box,
  Typography,
  Divider,
  Paper,
  Stack,
} from "@mui/material";
import { Notification } from "../../../../utils/commonApis";

interface WastageDecreaseNotificationProps {
  notification: Notification;
}

interface WastageDecreaseData {
  RequestType: string;
  ProjectId: string;
  RawMaterialId: string;
  RawMaterialName: string;
  Quantity: number;
  Reason: string;
  RequestedBy: string;
  [key: string]: any;
}

const WastageDecreaseNotification: React.FC<WastageDecreaseNotificationProps> = ({ notification }) => {
  // Parse the wastage data from the notification
  let wastageData: WastageDecreaseData | null = null;
  try {
    wastageData = JSON.parse(notification.DataDump) as WastageDecreaseData;
  } catch (e) {
    console.error("Error parsing wastage data:", e);
  }

  if (!wastageData) {
    return (
      <ListItem divider>
        <ListItemText 
          primary="Invalid Wastage Decrease Notification" 
          secondary={`Error parsing notification data. Created at: ${new Date(notification.CreatedAt * 1000).toLocaleString()}`}
        />
      </ListItem>
    );
  }

  return (
    <Paper elevation={1} sx={{ mb: 2, overflow: "hidden" }}>
      <ListItem sx={{ bgcolor: "#f8f9fa" }}>
        <ListItemText
          primary={
            <Typography variant="subtitle1" fontWeight="bold">
              Wastage Decrease Request
            </Typography>
          }
          secondary={`Created: ${new Date(notification.CreatedAt * 1000).toLocaleString()}`}
        />
      </ListItem>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Stack spacing={1}>
          <Typography variant="body2">
            <strong>Project ID:</strong> {wastageData.ProjectId}
          </Typography>
          <Typography variant="body2">
            <strong>Material:</strong> {wastageData.RawMaterialName}
          </Typography>
          <Typography variant="body2">
            <strong>Quantity:</strong> {wastageData.Quantity}
          </Typography>
          <Typography variant="body2">
            <strong>Reason:</strong> {wastageData.Reason}
          </Typography>
          <Typography variant="body2">
            <strong>Requested By:</strong> {wastageData.RequestedBy}
          </Typography>
        </Stack>
      </Box>
      <Divider />
      <Box sx={{ p: 1.5, display: "flex", justifyContent: "flex-end", gap: 1 }}>
        {notification.Status === 'pending' && (
          <>
            <Button 
              variant="outlined" 
              color="error" 
              size="small"
            >
              Reject
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              size="small"
            >
              Approve
            </Button>
          </>
        )}
        {notification.Status === 'accepted' && (
          <Typography variant="body2" color="success.main">
            This wastage decrease request has been approved
          </Typography>
        )}
        {notification.Status === 'rejected' && (
          <Typography variant="body2" color="error">
            This wastage decrease request has been rejected
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default WastageDecreaseNotification;